import { SVGProps } from 'react'

export const ArrowLeft = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1866 19.3732L3 12.1866L10.1866 4.99998L11.2293 6.04264L5.8226 11.4493L21 11.4493V12.9239L5.8226 12.9239L11.2293 18.3306L10.1866 19.3732Z"
      fill="currentColor"
    />
  </svg>
)

